import { graphql, useStaticQuery } from 'gatsby';

export const useNotification = (): Queries.Maybe<Queries.Squidex_Notification> => {
  const data = useStaticQuery<Queries.Query>(query);

  return data.squidex.findNotificationSingleton;
};

const query = graphql`
  query useNotificationQuery {
    squidex {
      findNotificationSingleton {
        data {
          text {
            de
            en
          }
        }
        flatData {
          type
          visibleUntil
        }
      }
    }
  }
`;
